module.exports = __webpack_public_path__ + "static/media/MenuButton.991425d6.svg";